type IconProps = React.ComponentProps<'svg'>

export function ColorsIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C14.4779 0 17.5 3.02208 17.5 6.75C17.5 7.35082 17.4198 7.93285 17.2725 8.4873C19.7505 9.48637 21.5 11.9131 21.5 14.75C21.5 18.4779 18.4779 21.5 14.75 21.5C13.2528 21.5 11.8685 21.0116 10.749 20.1865C9.62958 21.0113 8.24717 21.5 6.75 21.5C3.02208 21.5 0 18.4779 0 14.75C0 11.9134 1.74901 9.48659 4.22656 8.4873C4.0793 7.93292 4 7.35073 4 6.75C4 3.02208 7.02208 0 10.75 0ZM4.77246 9.88477C2.85268 10.6658 1.5 12.5508 1.5 14.75C1.5 17.6495 3.8505 20 6.75 20C9.6495 20 12 17.6495 12 14.75C12 14.2871 11.9381 13.8395 11.8262 13.4131C11.4756 13.4693 11.1164 13.5 10.75 13.5C8.15394 13.5 5.90171 12.0337 4.77246 9.88477ZM16.7266 9.88477C15.9852 11.2953 14.7607 12.4104 13.2715 13.0107C13.4193 13.5664 13.5 14.1492 13.5 14.75C13.5 16.4275 12.8858 17.96 11.873 19.1406C12.6995 19.6834 13.687 20 14.75 20C17.6495 20 20 17.6495 20 14.75C20 12.5505 18.6468 10.6656 16.7266 9.88477ZM10.75 1.5C7.8505 1.5 5.5 3.85051 5.5 6.75C5.5 9.6495 7.8505 12 10.75 12C13.6495 12 16 9.6495 16 6.75C16 3.8505 13.6495 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
